import { z } from "zod";
import { BaseEvent } from "./base";
export const EventParsing_Fail = BaseEvent.extend({
    name: z.literal("events.superwall.com.feature.Events.EventParsing_Fail"),
    event: z.object({
        failed_events: z.any(z.object({}).passthrough())
    })
});
